import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Monetization")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"260px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row mb-4" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Revenue", -1)
const _hoisted_11 = { class: "fs-3 fw-bold" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "ARPU", -1)
const _hoisted_14 = { class: "fs-3 fw-bold" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "ARPPU", -1)
const _hoisted_17 = { class: "fs-3 fw-bold" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Refunds", -1)
const _hoisted_20 = { class: "fs-3 fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : (_ctx.loading && !_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString((_ctx.monetization.totalRevenue ?? 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.monetization.arpu, 3)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString((_ctx.monetization.arppu ?? 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.monetization.refunds ?? 0), 1)
                ])
              ]),
              _createVNode(_component_apexchart, {
                type: "area",
                height: "260",
                options: _ctx.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"])
            ], 64))
    ])
  ]))
}